import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080/api/v1';

export interface PublicProjectTheme {
  mode: 'dark' | 'light';
  accentColor: string;
}

export interface PublicProjectBounds {
  minLng: number;
  minLat: number;
  maxLng: number;
  maxLat: number;
}

export interface PublicProject {
  id: string;
  slug: string;
  /** Subdominio público personalizado (p.ej. "sanjuan" para sanjuan.wayline.city). */
  publicSubdomain: string | null;
  name: string;
  territory: string | null;
  subtitle: string | null;
  coverImageUrl: string | null;
  coverVideoUrl: string | null;
  coverPosterUrl: string | null;
  logoUrl: string | null;
  theme: PublicProjectTheme;
  publicEntryEnabled: boolean;
  bounds: PublicProjectBounds;
}

export interface PublicProjectListItem {
  id: string;
  slug: string;
  name: string;
  territory: string | null;
}

export const publicProjectsApi = {
  async list(): Promise<PublicProjectListItem[]> {
    const response = await axios.get<PublicProjectListItem[]>(`${API_URL}/public/projects`);
    return response.data;
  },

  async getBySlug(slug: string): Promise<PublicProject> {
    const response = await axios.get<PublicProject>(
      `${API_URL}/public/projects/${encodeURIComponent(slug)}`
    );
    return response.data;
  },

  /**
   * Resuelve un proyecto por su subdominio público (campo `public_subdomain`).
   * Usado al acceder desde {project}.wayline.city — el subdominio puede diferir
   * del slug interno del proyecto.
   */
  async getBySubdomain(subdomain: string): Promise<PublicProject> {
    const response = await axios.get<PublicProject>(
      `${API_URL}/public/projects/by-subdomain/${encodeURIComponent(subdomain)}`
    );
    return response.data;
  },
};
